<template>
  <div class="pageContent">
    <div class="lc-list width-1200">
      <div class="item-title">
        <h4>新县游</h4>
        <span @click="goList('玩在新县', '新县游')">更多>></span>
      </div>
      <div class="cont-list">
        <ul>
          <li
            class="width25"
            v-for="(item, index) in ltyDataList"
            :key="index"
            @click="goDetail('新县游', item)"
          >
            <img :src="imgURl + 'xxszxc/' + item.slt" />
            <div class="item-context">
              <p>{{ item.bt }}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="lc-list width-1200">
      <div class="item-title">
        <h4>探秘新县</h4>
        <span @click="goList('玩在新县', '探秘新县')">更多>></span>
      </div>
      <div class="village-content">
        <div class="village">
          <h4>新县乡镇</h4>
          <ul>
            <li
              :class="isOn == index ? 'bgcolor' : ''"
              @click="isOn = index"
              v-for="(item, index) in townList"
              :key="index"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div class="tmlt-box">
          <ul>
            <li
              v-for="(item, index) in tmltDataList"
              :key="index"
              @click="goDetail('探秘新县', item)"
            >
              <img :src="imgURl + 'xxszxc/' + item.slt" />
              <p>{{ item.bt }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="lc-list width-1200">
      <div class="item-title">
        <h4>美丽乡村</h4>
        <span @click="goList('玩在新县', '美丽乡村')">更多>></span>
      </div>
      <div class="xc-nav">
        <span
          :class="isNavOn == index ? 'navOn' : ''"
          @click="mlxcNavChange(index)"
          v-for="(item, index) in mlxcNavList"
          :key="index"
          >{{ item.name }}
        </span>
      </div>
      <!-- 图片列表 -->
      <div class="xcimg-list">
        <div
          v-for="(item, index) in xcimgList"
          :key="index"
          @click="goDetail('美丽乡村', item)"
        >
          <img :src="imgURl + 'xxszxc/' + item.slt" />
          <span>{{item.bt}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const imgURl = API_IMG_URL;
export default {
  data() {
    return {
      imgURl: imgURl,
      isOn: -1,
      isNavOn: 0,
      xcimgList: [],
      mlxcNavList: [
        {
          name: "热门",
        },
        {
          name: "特色村镇",
        },
        {
          name: "采摘农场",
        },
        {
          name: "农家乐",
        },
      ],
      tmltDataList: [],
      ltyDataList: [],
      townList: [
        {
          name: "金兰山街道",
        },
        {
          name: "新集镇",
        },
        {
          name: "沙窝镇",
        },
        {
          name: "吴陈河镇",
        },
        {
          name: "苏河镇",
        },
        {
          name: "八里畈镇",
        },
        {
          name: "浒湾乡",
        },
        {
          name: "周河乡",
        },
        {
          name: "陡山河乡",
        },
        {
          name: "千斤乡",
        },
        {
          name: "卡房乡",
        },
        {
          name: "郭家河乡",
        },
        {
          name: "陈店乡",
        },
        {
          name: "箭厂河乡",
        },
        {
          name: "泗店乡",
        },
        {
          name: "田铺乡",
        },
      ],
    };
  },
  components: {},
  methods: {
    goList(meunname, type) {
      this.$router.push({
        path: "list",
        query: {
          meunname: meunname,
          type: type,
        },
      });
    },
    goDetail(type, item) {
      this.$router.push({
        path: "detail",
        query: {
          type: type,
          title: item.pubTittle,
          id: item.id,
        },
      });
    },
    async getDataList(params) {
      let res = await this.$http.queryPageList(params);
      // pubType 31-新县游,32-探秘新县,33-美丽乡村
      if (params.pubType == 31) {
        this.ltyDataList = res.response.records;
      } else if (params.pubType == 32) {
        this.tmltDataList = res.response.records;
      } else if (params.pubType == 33) {
        this.xcimgList = res.response.records;
      }
    },
    mlxcNavChange(index) {
      this.isNavOn = index;
      let params = {
        currentPage: index + 1,
        pubType: 33,
        pageSize: 4,
      };
      this.getDataList(params);
    },
    initData() {
      let params1 = {
        currentPage: 1,
        pubType: 31,
        pageSize: 8,
      };
      this.getDataList(params1);
      let params2 = {
        currentPage: 1,
        pubType: 32,
        pageSize: 6,
      };
      this.getDataList(params2);
      let params3 = {
        currentPage: 1,
        pubType: 33,
        pageSize: 4,
      };
      this.getDataList(params3);
    },
  },
  mounted() {
    this.initData();
  },
};
</script>

<style lang="less" scoped>
.village-content {
  display: flex;
  justify-content: space-between;
  .village {
    width: 255px;
    height: 340px;
    // padding: 15px;
    background-color: #fff;
    text-align: center;
    h4 {
      font-size: 18px;
      font-weight: normal;
      margin-bottom: 10px;
    }
    ul {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      li {
        width: 115px;
        height: 30px;
        margin: 5px 0;
        line-height: 30px;
        text-align: center;
        border: 1px solid #ccc;
        border-radius: 25px;
        cursor: pointer;
        transition: all 0.1s ease-in-out;
        font-size: 16px;
        &.bgcolor {
          background-color: #d9d9d9;
          color: #fea004;
        }
      }
    }
  }
  .tmlt-box {
    width: 900px;
  }
}
.tmlt-box {
  ul {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    li {
      width: 290px;
      height: 180px;
      position: relative;
      margin-bottom: 10px;
      transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
      &:hover {
        box-shadow: 0 10px 50px rgba(58, 58, 58, 0.5);
        -webkit-transform: translateY(-10px);
        -moz-transform: translateY(-10px);
        transform: translateY(-10px);
        p {
          display: block;
        }
      }
      p {
        width: 290px;
        display: none;
        position: absolute;
        font-size: 16px;
        bottom: 0;
        left: 0;
        color: #fff;
        text-indent: 2em;
        height: 30px;
        line-height: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        transition: display 0.3s ease-in-out;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
.xc-nav {
  padding-bottom: 20px;
  text-align: center;
  span {
    padding: 5px 20px;
    cursor: pointer;
    font-size: 18px;
    &.navOn {
      border-bottom: 2px solid #02d4d5;
    }
  }
}
.xcimg-list {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  > div {
    width: 290px;
    height: 180px;
    transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
    &:hover {
      box-shadow: 0 10px 50px rgba(58, 58, 58, 0.5);
      -webkit-transform: translateY(-10px);
      -moz-transform: translateY(-10px);
      transform: translateY(-10px);
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
